import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from 'reactstrap'
import ProfileHeader from 'components/Headers/ProfileHeader.js'
import { updateCurrentUser } from 'store/user/actions'
import AxiosInstance from 'utils/AxiosInstance'
import './profile.css'
import Select from 'views/pages/Group/Select'
import { Eye } from 'react-feather'

// import { fetchCurrentUser } from 'store/user/actions'

function Profile() {
  const user = useSelector((state) => state.auth.user)
  const dispatch = useDispatch()

  const [userAvatar, setUserAvatar] = useState(user.avatar && user.avatar.url)
  const [userAvatarFile, setUserAvatarFile] = useState(null)
  const [firstname, setFirstname] = useState(user.first_name)
  const [lastname, setLastname] = useState(user.last_name)
  const [email, setEmail] = useState(user.email)
  const [language, setLanguage] = useState(user.language)

  const languageRedux = useSelector((state) => state?.language)
  const languageData = languageRedux || {}

  const [password, setPassword] = useState(null)
  const [newPassword, setNewPassword] = useState(null)
  const [confirmPassword, setConfirmPassword] = useState(null)

  const [profileHover, setProfileHover] = useState(false)

  const [rewards, setRewards] = useState(0)
  const [courses, setCourses] = useState(0)
  const [loading, setLoading] = useState(false)

  const [passwordInputs, setPasswordInputs] = useState({
    currentPassVisible: false,
    newPassVisible: false,
    confirmPassVisible: false,
  })

  const toggleCurrentPassInput = (currentInput) => {
    setPasswordInputs((prev) => ({
      ...prev,
      [currentInput]: !prev[currentInput],
    }))
  }

  useEffect(() => {
    getCourses()
    getRewards()
  }, [])

  const updateUser = (e) => {
    e.preventDefault()

    const data = new FormData()

    if (userAvatarFile !== null && userAvatarFile !== undefined) {
      data.append('file', userAvatarFile)
    }
    if (firstname === '' || lastname === '' || email === '') {
      alert('Empty field not allowed')
      return
    }
    data.append('id', user.id)
    data.append('first_name', firstname)
    data.append('last_name', lastname)
    data.append('email', email)
    data.append('language', language)

    console.log(language)

    AxiosInstance.put('/users/self', data)
      .then((res) => {
        if (res.token) {
          toast.success('Your settings have been saved!', {
            position: toast.POSITION.BOTTOM_LEFT,
          })
          //spread current data and then update with response
          const changedUser = { ...user, ...res }
          dispatch(updateCurrentUser(changedUser))

          setTimeout(() => {
            window.location = `/`
          }, 2000)
        } else if (res.error && res.message === 'Duplicated email') {
          toast.error('This email is already taken, please type a new one')
        }
      })
      .then((err) => console.log(err))
  }

  const getRewards = async () => {
    const rewards = await AxiosInstance.get(`/rewards`)
    setRewards(rewards.length)
  }

  const onImageChange = (e) => {
    const [file] = e.target.files
    setUserAvatar(URL.createObjectURL(file))

    setUserAvatarFile(file)

    const data = new FormData()

    if (file && file !== undefined) {
      data.append('file', file)
      console.log(file)
    }

    data.append('id', user.id)
    data.append('first_name', firstname)
    data.append('last_name', lastname)
    data.append('email', email)
    data.append('language', language)

    AxiosInstance.put('/users/self', data)
      .then((res) => {
        if (res.token) {
          toast.success('Saved Success!', {
            position: toast.POSITION.BOTTOM_LEFT,
          })
          const changedUser = { ...user, ...res }
          dispatch(updateCurrentUser(changedUser))
        } else if (res.error && res.message === 'Duplicated email') {
          toast.error('This email is already taken, please type a new one')
        }
      })
      .then((err) => console.log(err))
  }

  const handleSavePassword = (e) => {
    e.preventDefault()

    AxiosInstance.post('/users/self/change-password', {
      password,
      newPassword,
      confirmPassword,
    }).then((res) => {
      if (res.success) {
        toast.success('Saved Success!', {
          position: toast.POSITION.BOTTOM_LEFT,
        })
      } else {
        if (newPassword !== confirmPassword) {
          toast.error("Passwords don't match", {
            position: toast.POSITION.BOTTOM_LEFT,
          })
        } else {
          toast.error(res.message, {
            position: toast.POSITION.BOTTOM_LEFT,
          })
        }
      }
    })
  }

  const getCourses = async () => {
    setLoading(true)
    const coursesLength = await AxiosInstance.get('/courses/all')
    setLoading(false)
    if (Array.isArray(coursesLength)) {
      setCourses(coursesLength.length)
    }
  }

  return (
    <>
      <ProfileHeader />
      <Container
        className='information-container'
        style={{ marginTop: '-250px' }}
        fluid
      >
        <Row>
          <Col
            className='order-xl-2 profile-container'
            xl='4'
            // style={{ marginTop: '70px' }}
          >
            <Card className='card-profile overflow_unset'>
              <Row className='justify-content-center'>
                <Col className='order-lg-2' lg='3'>
                  <div className='d-flex justify-content-center'>
                    <div
                      className='circle-profile absolute-profile'
                      onMouseEnter={() => setProfileHover(true)}
                      onMouseLeave={() => setProfileHover(false)}
                    >
                      <div className='overlay-hover-profile'>
                        <div className='d-flex justify-content-center	'>
                          <Input
                            type='file'
                            className='img-input-style-profile'
                            onChange={onImageChange}
                          />
                          <img
                            src={userAvatar}
                            alt='profile'
                            className='styledImage-profile'
                            style={{ objectFit: 'cover' }}
                          />
                        </div>
                      </div>
                      <div
                        className={`overlay-hover2-profile ${
                          profileHover ? '' : 'd-none'
                        }`}
                      >
                        <div className='d-flex justify-content-center'>
                          <Input
                            type='file'
                            className='img-input-style-profile'
                            onChange={onImageChange}
                          />
                          <div className='overlay-text '>
                            <i className='ni ni-camera-compact mb-2' />
                            <p style={{ lineHeight: '19px' }}>
                              Change Profile Image
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <CardBody className='p-0 mt-4'>
                <Row className='card-profile-stats d-flex justify-content-center '>
                  <Col xl='9' className='col-10 h2 mt-2 '>
                    <div className='card-profile-stats d-flex justify-content-around '>
                      {/* <div>
                        <span className='heading'>{rewards || 0}</span>
                        <span className='h5'>
                          {languageData?.language?.data?.general
                            ? languageData?.language?.data.general.rewards
                            : null}
                        </span>
                      </div> */}
                      <div>
                        <span className='heading'>
                          {loading ? '. . . ' : courses}
                        </span>
                        <span className='h5'>
                          {courses !== 1 ? 'Courses' : 'Course'}
                        </span>
                      </div>
                      {/* <div>
                        <span className='heading'>9</span>
                        <span className='h5'>Quizes</span>
                      </div> */}
                    </div>
                    <hr />
                  </Col>
                </Row>

                <div
                  style={{ height: '230px' }}
                  className='user-information  d-flex justify-content-start align-items-center flex-column text-center '
                >
                  <h5 className='h2'>
                    {user.first_name + ' ' + user.last_name}
                  </h5>
                  <div className='h5 font-weight-200'>{user?.location}</div>
                  {/* <div className='h5'>Solution Manager</div>
                  <div className='h5'>Cashier</div> */}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col className='order-xl-1' xl='8'>
            <Card>
              <CardHeader>
                <Row className='align-items-center'>
                  <Col xs='8'>
                    <h3 className='mb-0'>Edit profile</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <div className='pl-lg-4'>
                    <Row>
                      <Col lg='6'>
                        <FormGroup>
                          <label
                            className='form-control-label'
                            htmlFor='input-username'
                          >
                            Username
                          </label>
                          <Input
                            defaultValue={user.username}
                            disabled
                            id='input-username'
                            placeholder='Username'
                            type='text'
                          />
                        </FormGroup>
                      </Col>
                      <Col lg='6'>
                        <FormGroup>
                          <label
                            className='form-control-label'
                            htmlFor='input-email'
                          >
                            {languageData?.language?.data.general
                              ? languageData?.language?.data.general.email
                              : null}
                          </label>
                          <Input
                            defaultValue={user.email}
                            onChange={(e) => setEmail(e.target.value)}
                            id='input-email'
                            placeholder='jesse@example.com'
                            type='email'
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg='6'>
                        <FormGroup>
                          <label
                            className='form-control-label'
                            htmlFor='input-first-name'
                          >
                            {languageData?.language?.data.general
                              ? languageData?.language?.data.general.first_name
                              : null}
                          </label>
                          <Input
                            defaultValue={user.first_name}
                            onChange={(e) => setFirstname(e.target.value)}
                            id='input-first-name'
                            placeholder='First name'
                            type='text'
                          />
                        </FormGroup>
                      </Col>
                      <Col lg='6'>
                        <FormGroup>
                          <label
                            className='form-control-label'
                            htmlFor='input-last-name'
                          >
                            {languageData?.language?.data.general
                              ? languageData?.language?.data.general.last_name
                              : null}
                          </label>
                          <Input
                            defaultValue={user.last_name}
                            onChange={(e) => setLastname(e.target.value)}
                            id='input-last-name'
                            placeholder='Last name'
                            type='text'
                          />
                        </FormGroup>
                      </Col>
                      <Col lg='6'>
                        <FormGroup>
                          <label
                            className='form-control-label'
                            htmlFor='input-last-name'
                          >
                            {languageData?.language?.data.settings
                              ? languageData?.language?.data.settings.language
                              : null}
                          </label>
                          <Select
                            options={languageData.languages}
                            selectedOptions={language || user.language}
                            onChange={(value) => setLanguage(value.option.id)}
                            valueKey={'id'}
                            multi={false}
                            language={languageData}
                            placeholder={
                              language.general &&
                              language.general.select_language
                                ? language.general.select_language
                                : 'Select Language'
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className='d-flex justify-content-end'>
                      <Button
                        type='submit'
                        className='bg-dark text-white px-4 rounded-pill py-1'
                        onClick={updateUser}
                      >
                        {languageData?.language?.data.general
                          ? languageData?.language?.data.general.save
                          : null}
                      </Button>
                    </div>
                  </div>
                </Form>
                <hr className='my-4' />

                <h6 className='heading-small text-muted mb-4'>
                  Change your password
                </h6>
                <Form>
                  <div className='pl-lg-4'>
                    <Row>
                      <Col lg='6'>
                        <FormGroup>
                          <label
                            className='form-control-label'
                            htmlFor='input-address'
                            style={{ userSelect: 'none' }}
                          >
                            {languageData?.language?.data.my_profile
                              ? languageData?.language?.data.my_profile
                                  .current_password
                              : null}
                          </label>
                          <div className='password-input'>
                            <Input
                              id='input-address'
                              placeholder='Current Password'
                              type={
                                passwordInputs.currentPassVisible
                                  ? 'text'
                                  : 'password'
                              }
                              onChange={(e) => {
                                setPassword(e.target.value)
                              }}
                            />
                            <div
                              className='eye'
                              onClick={() =>
                                toggleCurrentPassInput('currentPassVisible')
                              }
                            >
                              <Eye />
                            </div>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg='6'>
                        <FormGroup>
                          <label
                            className='form-control-label'
                            htmlFor='input-city'
                            style={{ userSelect: 'none' }}
                          >
                            {languageData?.language?.data.my_profile
                              ? languageData?.language?.data.my_profile
                                  .new_password
                              : null}
                          </label>
                          <div className='password-input'>
                            <Input
                              id='input-city'
                              placeholder='New Password'
                              type={
                                passwordInputs.newPassVisible
                                  ? 'text'
                                  : 'password'
                              }
                              onChange={(e) => {
                                setNewPassword(e.target.value)
                              }}
                            />

                            <div
                              className='eye'
                              onClick={() =>
                                toggleCurrentPassInput('newPassVisible')
                              }
                            >
                              <Eye />
                            </div>
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg='6'>
                        <FormGroup>
                          <label
                            className='form-control-label'
                            htmlFor='input-country'
                            style={{ userSelect: 'none' }}
                          >
                            {languageData?.language?.data.my_profile
                              ? languageData?.language?.data.my_profile
                                  .confirm_new_password
                              : null}
                          </label>
                          <div className='password-input'>
                            <Input
                              id='input-country'
                              placeholder='Confirm New Password'
                              type={
                                passwordInputs.confirmPassVisible
                                  ? 'text'
                                  : 'password'
                              }
                              onChange={(e) => {
                                setConfirmPassword(e.target.value)
                              }}
                            />

                            <div
                              className='eye'
                              onClick={() =>
                                toggleCurrentPassInput('confirmPassVisible')
                              }
                            >
                              <Eye />
                            </div>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className='d-flex justify-content-end'>
                      <Button
                        type='submit'
                        className='bg-dark text-white px-4 rounded-pill py-1'
                        onClick={handleSavePassword}
                      >
                        {languageData?.language?.data.general
                          ? languageData?.language?.data.general.save
                          : null}
                      </Button>
                    </div>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <ToastContainer />
      </Container>
    </>
  )
}

export default Profile
